export default __webpack_public_path__ + "static/media/twitch-brands.48a41415.svg";